<template>
  <div class="chart">
    <div ref="barChart" :style="{ height: height, width: width }" />
  </div>
</template>

<script>
import * as echarts from "echarts/core";

export default {
  name: "contrastBarView",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "350px",
    },
    barWidth: {
      type: String,
      default: "14px",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: "canvas",
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.setOptions();
      },
    },
  },
  mounted() {
    this.initChart();
    if (this.autoResize) {
      window.addEventListener("resize", this.resizeHandler);
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    if (this.autoResize) {
      window.removeEventListener("resize", this.resizeHandler);
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    resizeHandler() {
      this.chart.resize();
    },
    initChart() {
      this.chart = echarts.init(this.$refs.barChart, "", {
        renderer: this.type,
      });
      this.initChartOption();
      this.chart.on("click", this.handleClick);
    },
    initChartOption() {
      const _this = this;
      this.chart.setOption({
        // dataZoom: [
        //   {
        //     type: "inside",
        //     realtime: true
        //   },
        //   {
        //     show: true,
        //     xAxisIndex: [0],
        //     realtime: true,
        //     height: 4, //这里可以设置dataZoom的尺寸
        //     bottom: "2%",
        //     backgroundColor: "#1d76e6", // 填充颜色
        //     textStyle: {
        //       color: "#fff" // 左右两边文字颜色
        //     }
        //   }
        // ],
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(0, 0, 0, 0.63)", //设置背景颜色
          textStyle: {
            color: "#fff",
          },
          borderColor: "rgba(255,255,255, .5)",
          axisPointer: {
            type: "shadow",
          },
          formatter: "{b}月<br>入栏：{c}<br>出栏：{c1}",
        },
        grid: {
          left: "5%",
          right: "15%",
          bottom: "5%",
          top: "15%",
          containLabel: true,
        },
        legend: {
          data: ["入栏", "出栏"],
          icon: "rect",
          right: "2%",
          textStyle: {
            color: "#fff",
            fontSize: 14,
          },
          itemWidth: 14,
          itemHeight: 4,
          itemGap: 35,
          color: "#fff",
          // selectedMode: false,
        },
        xAxis: {
          type: "category",
          name: "季度",
          data: _this.data.month,
          nameTextStyle: {
            color: "#b5dbff",
            fontSize: "14px",
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(45, 60, 92, 1)",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              fontFamily: "Microsoft YaHei",
              color: "#b5dbff", // x轴颜色
              fontWeight: "normal",
              fontSize: "14",
              lineHeight: 22,
            },
            interval: 0, //标签设置为全部显示
            lineHeight: 15,
          },
        },

        yAxis: [
          {
            min: 0,
            type: "value",
            name: "头",
            nameTextStyle: {
              color: "#b5dbff",
              fontSize: "14px",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(45, 60, 92, 1)",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(45, 60, 92, .3)", //左侧显示线
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              //  formatter: "{value}%",
              textStyle: {
                color: "#b5dbff",
                fontSize: 14,
              },
            },
          },
        ],
        series: [
          /* // 入栏中间正方形
                    {
                        type: "pictorialBar",
                        symbol: "diamond",
                        symbolSize: [_this.barWidth, 8],
                        symbolOffset: [-8, -4],
                        symbolPosition: "end",
                        legendHoverLink:true,
                        z: 12,
                        color: "#00DEFF",
                        data: _this.data.enterCount,
                    },
                    // 出栏中间正方形
                    {
                        type: "pictorialBar",
                        symbol: "diamond",
                        symbolSize: [_this.barWidth, 8],
                        symbolOffset: [8, -4],
                        symbolPosition: "end",
                        legendHoverLink: true,
                        z: 12,
                        color: "#fcab2b",
                        data: _this.data.exitType
,
                    },
                    //  入栏正方形
                    {
                        type: "pictorialBar",
                        symbol: "diamond",
                        symbolSize: [_this.barWidth, 8],
                        symbolOffset: [-8, -4],
                        z: 12,
                        color: "rgba(0, 187, 233, 0.1)",
                        data: _this.data.enterCount,
                    },
                    // 出栏正方形
                    {
                        type: "pictorialBar",
                        symbol: "diamond",
                        symbolSize: [_this.barWidth, 8],
                        symbolOffset: [8, -4],
                        color: "rgba(252,171,43,0.1)",
                        z: 12,
                        data: _this.data.exitType,
                    }, */
          // 入栏进度柱子
          {
            name: "入栏",
            type: "bar",
            barWidth: _this.barWidth,
            // zlevel: 2,
            stack: "1",
            itemStyle: {
              normal: {
                opacity: 0.7,
                color: "#00bbe9",
              },
            },
            label: {
              show: false,
              position: ["-18", "-18"],
              color: "#eca330",
              fontSize: 12,
            },
            data: _this.data.enterCount,
          },
          // 出栏进度柱子
          {
            name: "出栏",
            type: "bar",
            stack: "4",
            barWidth: _this.barWidth,
            itemStyle: {
              normal: {
                opacity: 0.7,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#eca330",
                  },
                  {
                    offset: 1,
                    color: "#eca330",
                  },
                ]),
                barBorderRadius: 0,
              },
            },
            label: {
              show: false,
              position: ["18", "-18"],
              color: "#eca330",
              fontSize: 12,
            },
            data: _this.data.exitType,
          },
        ],
      });
    },
    handleClick(params) {
      this.$emit("click", params);
    },
    setOptions() {
      this.clearChart();
      this.resizeHandler();
      if (this.chart) {
        this.initChartOption();
      }
    },
    refresh() {
      this.initChartOption();
    },
    clearChart() {
      this.chart && this.chart.clear();
    },
  },
};
</script>
